import * as React from 'react';
import './LiquidacionDetalleModal.css';

export default function DetalleVerBoton({
    onClick,
    title = 'Ver detalle',
    label = 'Ver',
    iconClass = 'fa-eye',
}) {
    return (
        <button
            type="button"
            className="liquidacion-detalle-ver-btn"
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            title={title}
            aria-label={title}
        >
            <i className={`fa ${iconClass}`} aria-hidden="true" />
            <span className="liquidacion-detalle-ver-btn__text">{label}</span>
        </button>
    );
}
